import React from 'react';
import { object, shape, string } from 'prop-types';
import Button from '../../../components/Button';
import { getLoginURL } from '../../../utils/redirect-utils';

const SignInButtonPanel = ({ decodedToken, destPath, emails }) => (
  <Button
    title="Sign In"
    id="loginButton"
    name="loginButton"
    value="Sign In"
    onClick={() => { window.location.href = getLoginURL(decodedToken || destPath, emails.to); }}
    style={{
      marginTop: '6px',
      width: '100%',
    }}
    primary
    className="cdlBtn"
  />
);

SignInButtonPanel.propTypes = {
  decodedToken: object.isRequired,
  destPath: shape({
    dest: string,
    path: string,
    retURL: string,
  }),
  emails: shape({
    to: string,
    from: string,
  }).isRequired,
};

SignInButtonPanel.defaultProps = {
  destPath: {
    retURL: null,
  },
};

export default SignInButtonPanel;
